import React from "react";

export const ProgressTitle = ({ title }) => {
  return <h1 className="historial">{title}</h1>;
};
